var template = require('./feedbackCategoryHelp.twig');

export class FeedbackHelp {
    constructor() {
        this.dom = $(twig({ data: template }).render());
        $('body').append(this.dom);

        $(this.dom).find('#close_feedback_help').on('click', (event) => {
            event.preventDefault();
            this.hide();
        });

        $(document).on('click.feedbackHelp', (event) => {
            if (
                this.dom.is(':visible') &&
                !$(event.target).closest(this.dom).length &&
                !$(event.target).closest('.help-icon').length
            ) {
                this.hide();
            }
        });
    }

    show() {
        this.dom.addClass('show');
        this.dom.css({
            display: 'block',
            position: 'absolute',
            top: '100px',
            left: '50%',
            transform: 'translateX(-50%)',
            'z-index': 1050
        });
    }

    hide() {
        this.dom.removeClass('show');
        this.dom.hide();
    }
}
